import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { SERVER_URL } from "@/config/config";
import { RankListInfo } from "@/types/Contract/Profile/RankListInfo";

export interface AssociateState {
  rankList: RankListInfo[];
  isLoadingRankList: boolean;
}

const initialState: AssociateState = {
  rankList: [],
  isLoadingRankList: false,
};

export const getRankListAction = createAsyncThunk(
  "associate/getRankList",
  async ({ from, count }: { from: number; count: number }) => {
    const response = await axios.get(
      `${SERVER_URL}/profile/rank?from=${from}&count=${count}`
    );

    return response.data as RankListInfo[];
  }
);

const associateSlice = createSlice({
  name: "associate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRankListAction.pending, (state) => {
      state.isLoadingRankList = true;
    });
    builder.addCase(getRankListAction.fulfilled, (state, { payload }) => {
      state.rankList = payload;
      state.isLoadingRankList = false;
    });
    builder.addCase(getRankListAction.rejected, (state) => {
      state.isLoadingRankList = false;
    });
  },
});

export default associateSlice.reducer;
